import React from "react";
import { Apple, Smartphone, Monitor, Laptop, Globe } from "lucide-react";

const Card = ({ Icon, title, steps, testid }) => (
  <div className="rounded-xl border border-slate-200 bg-white p-5" data-testid={testid}>
    <div className="flex items-center gap-2 font-semibold text-slate-900"><Icon className="w-5 h-5 text-[#006090]" /> {title}</div>
    <ol className="mt-3 space-y-1.5 text-sm text-slate-600 list-decimal pl-5">
      {steps.map((s, i) => <li key={i}>{s}</li>)}
    </ol>
  </div>
);

export default function InstallHelp() {
  return (
    <div className="min-h-screen bg-slate-50" data-testid="install-help-page">
      <div className="bg-[#0F2B5B] text-white">
        <div className="max-w-3xl mx-auto px-6 py-8">
          <div className="text-xl font-extrabold tracking-wide">Top-Recruit</div>
          <h1 className="text-2xl sm:text-3xl font-bold mt-2">Install Top-Recruit</h1>
          <p className="text-slate-300 mt-1 text-sm">Installation is optional. Top-Recruit works fully in any web browser — installing just adds an app icon for quicker access to the same account.</p>
        </div>
      </div>
      <div className="max-w-3xl mx-auto px-6 py-8 space-y-4">
        <div className="rounded-xl border border-emerald-200 bg-emerald-50 p-4 flex items-start gap-2" data-testid="install-browser">
          <Globe className="w-5 h-5 text-emerald-600 shrink-0 mt-0.5" />
          <p className="text-sm text-emerald-900"><strong>No installation required.</strong> Open Top-Recruit in Safari, Chrome, or Edge on any computer, tablet, or phone and sign in.</p>
        </div>
        <Card Icon={Apple} title="iPhone & iPad (Safari)" testid="install-ios" steps={[
          "Open Top-Recruit in the Safari browser.",
          "Tap the Share button (the square with an up arrow).",
          "Scroll down and tap “Add to Home Screen”.",
          "Tap “Add”. The Top-Recruit icon appears on your Home Screen.",
        ]} />
        <Card Icon={Smartphone} title="Android (Chrome)" testid="install-android" steps={[
          "Open Top-Recruit in the Chrome browser.",
          "Tap the ⋮ menu (top right).",
          "Tap “Install app” (or “Add to Home screen”).",
          "Confirm — Top-Recruit is added to your apps.",
        ]} />
        <Card Icon={Monitor} title="Windows (Edge or Chrome)" testid="install-windows" steps={[
          "Open Top-Recruit in Edge or Chrome.",
          "Click the install icon in the address bar (a monitor with a down arrow), or open the ⋮ menu → “Apps” / “Install Top-Recruit”.",
          "Click “Install”. Launch it anytime from the Start menu or desktop.",
        ]} />
        <Card Icon={Laptop} title="Mac (Chrome or Edge)" testid="install-mac" steps={[
          "Open Top-Recruit in Chrome or Edge.",
          "Click the install icon in the address bar, or open the ⋮ menu → “Install Top-Recruit…”.",
          "Click “Install”. Top-Recruit opens in its own window and appears in Launchpad.",
          "Safari on macOS: use File → “Add to Dock” (macOS Sonoma or later).",
        ]} />
        <p className="text-center text-xs text-slate-400 pt-2">The installed app and the browser version use the same Top-Recruit account and features.</p>
      </div>
    </div>
  );
}
